import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { useFeatureConfig } from '../../core/context/FeaturesContext';
import { registerCharacterLimit } from './registerCharacterLimit';

/** Enforces `features.characterLimit.max`; plain mode only (see the registry). */
export const CharacterLimitPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const max = useFeatureConfig('characterLimit')?.max;

  useEffect(() => (max ? registerCharacterLimit(editor, max) : undefined), [editor, max]);

  return null;
};
